<template>
    <div class="card">
        <div class="card-body">
            <form class="row" @submit.prevent="submitUserDataHandler">
                <div class="form-group col-12">
                    <label for="email">Email</label>
                    <input
                        id="email"
                        v-model="user.email"
                        :class="{
                            'is-invalid': $v.user.email.$error || isEmailTaken
                        }"
                        class="form-control"
                        type="text"
                        @input="isEmailTaken = false"
                    />
                    <div v-if="isEmailTaken" class="invalid-feedback">
                        Email already taken!
                    </div>
                </div>
                <div class="form-group col-12">
                    <label for="phone">Phone</label>
                    <input
                        id="phone"
                        v-model="user.phone"
                        :class="{
                            'is-invalid': $v.user.phone.$error || isPhoneTaken
                        }"
                        class="form-control"
                        type="text"
                        @input="isPhoneTaken = false"
                    />
                    <div v-if="isPhoneTaken" class="invalid-feedback">
                        Phone already taken!
                    </div>
                </div>
                <div class="form-group col-12">
                    <label for="firstName">First Name</label>
                    <input
                        id="firstName"
                        v-model="user.firstName"
                        :class="{
                            'is-invalid': $v.user.firstName.$error
                        }"
                        class="form-control"
                        type="text"
                    />
                </div>
                <div class="form-group col-12">
                    <label for="lastName">Last Name</label>
                    <input
                        id="lastName"
                        v-model="user.lastName"
                        :class="{
                            'is-invalid': $v.user.lastName.$error
                        }"
                        class="form-control"
                        type="text"
                    />
                </div>
                <div class="col-12 form-group">
                    <label for="avatar">Avatar</label>
                    <media-chooser
                        v-model="user.avatarId"
                        type="image"
                        id-only
                    />
                </div>
                <div class="col-12">
                    <button
                        type="submit"
                        class="btn btn-success waves-effect waves-light"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';
import validatePhoneFormat from '@/helpers/validatePhoneFormat';

export default {
    validations: {
        user: {
            email: {
                required,
                email
            },
            phone: {
                required,
                isFormatValid: v => validatePhoneFormat(v)
            },
            firstName: {
                required,
                minLength: minLength(2)
            },
            lastName: {
                required,
                minLength: minLength(2)
            }
        }
    },

    data() {
        return {
            user: {},
            isEmailTaken: false,
            isPhoneTaken: false
        };
    },

    computed: {
        ...mapGetters({
            loggedUser: 'auth/loggedUser'
        })
    },

    created() {
        this.user = {
            email: this.loggedUser.email,
            phone: this.loggedUser.phone,
            firstName: this.loggedUser.firstName,
            lastName: this.loggedUser.lastName,
            avatarId: this.loggedUser.avatarId,
            campuses: []
        };
    },

    methods: {
        ...mapActions({
            updateProfile: 'auth/updateProfile'
        }),

        async submitUserDataHandler() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.updateProfile(this.user);

                this.$toaster('Account has been updated!');
            } catch (err) {
                console.error(err);

                const { response } = err;

                if (response && response.status === 400) {
                    if (response.data.errors.some(e => e.param === 'email')) {
                        this.isEmailTaken = true;
                    } else if (
                        response.data.errors.some(e => e.param === 'phone')
                    ) {
                        this.isPhoneTaken = true;
                    }
                } else {
                    this.$toasterError();
                }
            }
        }
    }
};
</script>
